import BroadcastChannelActionEnum from "./broadcast.channel.action.enum"
import userService from "./user.service"
import router from "../router/main-router"
import { publicUrls } from "../config/public-actions.config"
const channel = new BroadcastChannel("app.esesja.exchange.channel")

export const broadcastChannelService = {
    init() {
        channel.onmessage = async (event) => {
            if (event == null || event.data == null || event.data.label == null) {
                return;
            }

            if(publicUrls.some(item => window.location.href.toLowerCase().includes(item.toLowerCase()))){
                return;
            }
            
            switch (event.data.label) {
                case BroadcastChannelActionEnum.Logout.label: { 
                    await userService.destroyer();
                } break;
                case BroadcastChannelActionEnum.Login.label: {
                    await userService.me();
                    await router.push({ name: "home" });
                }
            }
        }
    },
    notifyLogin() {
        channel.postMessage(BroadcastChannelActionEnum.Login);
    },
    notifyLogout() {
        channel.postMessage(BroadcastChannelActionEnum.Logout);
    }
}